<template>
  <div class="relative">
    <VueSlickCarousel v-bind="settings">
      <slot />
        <template #prevArrow>
            <button class="absolute bottom-0 lg:bottom-5 right-10 z-50 group transition-all hover:pr-2">
                <i class="fa-light fa-arrow-left text-2xl group-hover:text-lys"></i>
            </button>
        </template>
        <template #nextArrow>
            <button class="absolute bottom-0 lg:bottom-5 right-0 z-50 group transition-all hover:pl-2 hover:-right-2">
                <i class="fa-light fa-arrow-right text-2xl group-hover:text-lys"></i>
            </button>
        </template>

    </VueSlickCarousel>
  </div>
</template>
 
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
//import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'ImageSlider',
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        arrows: true,
        dots: false,
        infinite: false,
        touch: true
      },
    };
  },
};
</script>